export default function GameTitle() {
  return (
    <div className="text-center">
      <img
        className="game-heading"
        src={`${process.env.PUBLIC_URL}/assets/images/puzzle/heading.png`}
        alt="Game Heading"
      />
    </div>
  );
}